import React from "react";
import classNames from "classnames/bind";
import { Package, Loader2 } from "lucide-react";
import { Link } from "react-router-dom";
import OrderItem from "./OrderItem";
import Pagination from "./Pagination";
import styles from "../ProfilePage.module.scss";
import useTranslations from "../../../hooks/useTranslations"; // Điều chỉnh path tùy theo cấu trúc project

const cx = classNames.bind(styles);

const OrdersList = ({
  orderHistory,
  isLoading,
  currentPage,
  onPageChange,
  expandedShipping,
  expandedItems,
  toggleShippingInfo,
  toggleOrderItems,
  getStatusColor,
  getStatusText,
  getPaymentStatusText,
  getPaymentMethodText
}) => {
  const currentTranslations = useTranslations();
  
  const totalPages = orderHistory?.total_pages ? parseInt(orderHistory.total_pages) : 1;

  if (isLoading) {
    return (
      <div className={cx("empty-orders")}>
        <Loader2 size={48} className={cx("spinner")} />
        <h3>{currentTranslations?.OrdersList?.loading_orders}</h3>
      </div>
    );
  }

  if (!orderHistory?.orders || orderHistory.orders.length === 0) {
    return (
      <div className={cx("empty-orders")}>
        <Package size={48} />
        <h3>{currentTranslations?.OrdersList?.no_orders}</h3>
        <p>{currentTranslations?.OrdersList?.create_first_order}</p>
        <Link to="/" className={cx("shop-now-btn")}>
          {currentTranslations?.OrdersList?.shop_now}
        </Link>
      </div>
    );
  }

  return (
    <>
      <div className={cx("orders-list")}>
        {orderHistory.orders.map((order) => (
          <OrderItem
            key={order.order_id}
            order={order}
            expandedShipping={expandedShipping}
            expandedItems={expandedItems}
            toggleShippingInfo={toggleShippingInfo}
            toggleOrderItems={toggleOrderItems}
            getStatusColor={getStatusColor}
            getStatusText={getStatusText}
            getPaymentStatusText={getPaymentStatusText}
            getPaymentMethodText={getPaymentMethodText}
          />
        ))}
      </div>

      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={onPageChange}
          isLoading={isLoading}
        />
      )}
    </>
  );
};

export default OrdersList;